import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrientationService {
  private isLandscapeSubject = new BehaviorSubject<number>(0);  // '0' = portrait, '1' = landscape
  isLandscape$ = this.isLandscapeSubject.asObservable();

  setLandscape(value: number) {
    this.isLandscapeSubject.next(value);
  }
}